const getPreferredLocale = (): string => {
    if (typeof window === "undefined") return "en-SE";
    const culture = localStorage.getItem("culture") || "";
    const lang = localStorage.getItem("lang") || "";
    // Use the most specific valid locale first
    const pick = (l: string) =>
        l && Intl.NumberFormat.supportedLocalesOf([l]).length ? l : "";

    return pick(culture) || pick(lang) || navigator.language || "en-SE";
};
// Formats number with 2–4 decimals, localized
export const formatNumberForLocale = (value: number | null): string => {
    if (value == null) return "";
    const locale = getPreferredLocale();
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
    }).format(value);
};

// Parses localized number string to float
export const parseNumberFromLocale = (value: string): number | null => {
    if (!value) return null;

    const locale = getPreferredLocale();
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.67);
    const decimalSeparator = parts.find(p => p.type === "decimal")?.value || ".";
    const groupSeparator = parts.find(p => p.type === "group")?.value || ",";

    // Normalize NBSPs and remove grouping separators
    const normalized = value
        .replace(/\u00A0|\u202F/g, " ")        // normalize non-breaking spaces
        .replace(new RegExp(`\\${groupSeparator}`, "g"), "")
        .replace(new RegExp(`\\${decimalSeparator}`), ".")
        .replace(/[^\d.-]/g, "");

    const parsed = parseFloat(normalized);
    return isNaN(parsed) ? null : parsed;
};

// Formats number with exactly 2 decimals, localized
export const formatNumber = (value: number | null | undefined): string => {
    if (value == null) return "";
    const locale = getPreferredLocale();
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};